import React, { useContext, useState, useRef, useEffect, useLayoutEffect } from 'react';
import { AuthContext } from "../context/AuthContext.jsx";
import { AppContext } from '../context/AppContext.jsx';
import { useRoom } from '../context/RoomContext.jsx';
import RoomStatus from '../components/RoomStatus.jsx';
import Arcade from '../components/Arcade.jsx';
import Timer from './Timer.jsx';
import { useSfx } from "../hooks/useSfx.jsx";

function WaitingRoom({ setIsRoomActive }) {
	const { sessionInfo, setSessionInfo } = useContext(AuthContext);
	const { roomState } = useRoom();
	const [timeLeft, setTimeLeft] = useState(null);
	const sfx = useSfx();

	useEffect(() => {
		if (!roomState.status) return
		if (roomState?.status == "NotStarted") return;
		const time = new Date();
		time.setSeconds(time.getSeconds() + (location.hostname == "localhost" ? 3 : 5)); // 
		setTimeLeft(time);
	}, [roomState.status]);

	useEffect(() => {
		const unlock = () => sfx.ensureAudio?.();
		window.addEventListener('pointerdown', unlock, { once: true, passive: true });
		window.addEventListener('keydown', unlock, { once: true });
		return () => {
			window.removeEventListener('pointerdown', unlock);
			window.removeEventListener('keydown', unlock);
		};
	}, [sfx]);

	return (
		<>
			<RoomStatus />
			{roomState?.status && (
				<div style={{ animationDuration: "0.5s" }} className={`waiting-room container animate__animated animate__fadeIn ${roomState?.status != "NotStarted" ? "waiting-room-notstarted" : ""}`}>

					<div className="row align-items-center">
						<div className="col-12 col-lg-7 d-flex d-lg-block flex-column">

							{timeLeft && (
								<div style={{ minHeight: 240 }}>
									<Timer
										warnCountdownFrom={5}
										playWarn={sfx.playSelect}
										warnSfxEnabled={true}
										expiryTimestamp={timeLeft}
										className={'main-timer order-2 order-lg-1'}
										pad={1}
										playTimeUp={() => sfx.playSwoosh({ duration: 1.5 })}
										onExpire={() => setIsRoomActive(true)}
										expireSfxEnabled={true} />
								</div>
							)}

							{sessionInfo && (
								<>
									<div className="user-card d-lg-flex align-items-start justify-content-center justify-content-lg-center order-1 order-lg-2 mt-5 mt-lg-0 text-center text-lg-start">
										<img src={`/img/react-app/avatars/01/avatar-${sessionInfo.currentAvatarId}.png`} className="user-avatar user-avatar-main me-md-3 mx-auto" />
										<h3 className="fw-bold fs-2 text-center text-lg-start">
											<div className="display-3 fw-bold lh-1">{sessionInfo.nickName}</div>
											<div className={`fs-4 fs-lg-4 fw-normal`}>
												{roomState?.status == "NotStarted" && !sessionInfo.autoStartSurvey ? (
													<>
														<div className="fw-bold text-uppercase fs-3 fs-lg-2 mb-3" style={{ color: "#b1be7b", textShadow: "2px 2px 0px #4e890b" }}>
															Sei in sala d'attesa
														</div>
														Quando tutti i partecipanti
														saranno connessi inizierà il quiz. Nel frattempo sei pronto a far correre la nostra mascotte
														tra i pericoli che incontrerà sulla sua strada?</>
												) : <>Preparati, stai per entrare nel gioco...</>}
											</div>
										</h3>

									</div>
								</>
							)}
						</div>
						<div className="col-lg-4 text-end d-none d-lg-block" _style={{ minHeight: 400 }}>
							{sessionInfo.template?.mascotNormalMediaId ?
								<img src={`/api/trivia/media/${sessionInfo.template.mascotNormalMediaId}`} style={{ width: (roomState?.status == "NotStarted" ? 170 : 250) }} />
								: ""}
							{/*<div className={`mascotte mascotte-${timeLeft ? "big" : "medium"}`}></div>*/}
						</div>
					</div>
					{roomState?.status == "NotStarted" && !sessionInfo.autoStartSurvey && (
						<div className="row">
							<div className="col mt-5 mb-5">
								<div className="arcade-container">
									<Arcade
										characterSrc={`/api/trivia/media/${sessionInfo.template.mascotSmallMediaId}`}
										characterSrcGameOver={`/api/trivia/media/${sessionInfo.template.mascotDeadMediaId}`}
									/>
								</div>
							</div>
						</div>
					)}

				</div>
			)}
		</>

	);
}


export default WaitingRoom;
